// extracted by mini-css-extract-plugin
export default {"container":"WMHYxp","overlay":"iqV5n8","contentContainer":"jTzBty","innerContainer":"eIDG4c","actionItem":"ZJHoA2","actionLabel":"xywOcu","actionIcon":"joaqgl"};